import {isNumber} from 'underscore';

export default class allContentCountResponseMaker {
    data = [];
    data_to_send = allContentCountResponseMaker.defaultData();

    constructor(data) {
        this.data = data;
    }

    static defaultData = () => {
        return {
            contentTabCount: {
                articleCount: 0,
                eventCount: 0,
                otherCount: 0,
                videoCount: 0,
                allCount: 0,
            },
        };
    }
    process = async () => {
        let countResp = allContentCountResponseMaker.defaultData().contentTabCount;
        if (this.data.data.articlecount !== undefined &&
            this.data.data.articlecount !== null &&
            isNumber(this.data.data.articlecount)) {
            countResp['articleCount'] = this.data.data.articlecount
        }
        if (this.data.data.eventcount !== undefined &&
            this.data.data.eventcount !== null &&
            isNumber(this.data.data.eventcount)) {
            countResp['eventCount'] = this.data.data.eventcount;
        }
        if (this.data.data.othercount !== undefined &&
            this.data.data.othercount !== null &&
            isNumber(this.data.data.othercount)) {
            countResp['otherCount'] = this.data.data.othercount;
        }
        if (this.data.data.videoCount !== undefined &&
            this.data.data.videoCount !== null &&
            isNumber(this.data.data.videoCount)) {
            countResp['videoCount'] = this.data.data.videoCount;
        }
        countResp['allCount'] = countResp['videoCount'] + countResp['otherCount'] + countResp['eventCount'] + countResp['articleCount'];
        this.data_to_send.contentTabCount = countResp;
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}